// extracted by mini-css-extract-plugin
export default {"pendingPage":"Sh8tSUm9","content":"zgo4XPjV","icon":"cNGio4QR","title":"S47H7tfg","description":"A0TUTgbh","actions":"_RCM8vju","helpText":"yvG2JjLr","logoutButton":"xxcUZuO3"};